/**
 * Pagination data-hook props used for testing.
 */
/**
 * Pagination data-hook props used for testing.
 */
export var DataHooks;
(function (DataHooks) {
    DataHooks["currentPage"] = "current-page";
    DataHooks["totalPages"] = "total-pages";
    DataHooks["slashLabel"] = "slash-label";
    DataHooks["pageCompact"] = "page-compact";
    DataHooks["pageInputRoot"] = "page-input-root";
    DataHooks["pageStrip"] = "page-strip";
    DataHooks["pageStripRenderContainer"] = "page-strip-render-container";
    DataHooks["pageInput"] = "page-input";
    DataHooks["previous"] = "previous";
    DataHooks["next"] = "next";
    DataHooks["first"] = "first";
    DataHooks["last"] = "last";
    DataHooks["page"] = "page";
})(DataHooks || (DataHooks = {}));
export const HelperIds = {
    navButtonNext: 'navButtonNext',
    navButtonPrevious: 'navButtonPrevious',
    navButtonFirst: 'navButtonFirst',
    navButtonLast: 'navButtonLast',
    pageStrip: 'pageStrip',
    pageInput: 'pageInput',
    totalPages: 'totalPages',
    slash: 'slash',
    currentPage: 'currentPage',
    pageCompact: 'pageCompact',
};
//# sourceMappingURL=constants.js.map